// import React, { useState, useEffect, useContext } from 'react';
// import ProjectCard from './ProjectCard';
// import { ClaimPortalItems, ClaimPortalManagementItems } from "../data";
// import Layout from "../components/Layout";
// import { Sidebar } from "../components";
// import AuthContext from "../contexts/AuthContext";

// const ProjectDashboard = ({ data, onUpdateStatus, onViewHistory, userRole }) => {
//     const { authTokens, user } = useContext(AuthContext);
//   const statusConfig = {
//     going_smooth: {
//       title: 'Going Smooth',
//       icon: '✅',
//       color: '#10b981',
//       bgColor: '#d1fae5'
//     },
//     on_hold: {
//       title: 'On Hold',
//       icon: '⏸️',
//       color: '#f59e0b',
//       bgColor: '#fef3c7'
//     },
//     critical: {
//       title: 'Critical/Dangerous',
//       icon: '🚨',
//       color: '#ef4444',
//       bgColor: '#fee2e2'
//     },
//     closed: {
//       title: 'Closed',
//       icon: '✔️',
//       color: '#6b7280',
//       bgColor: '#f3f4f6'
//     },
//     no_status: {
//       title: 'No Status',
//       icon: '❓',
//       color: '#9ca3af',
//       bgColor: '#f9fafb'
//     }
//   };

//   const styles = {
//     dashboard: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '32px'
//     },
//     statusSection: {
//       background: 'white',
//       borderRadius: '12px',
//       padding: '24px',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//     },
//     statusSectionHeader: (color) => ({
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       marginBottom: '20px',
//       paddingBottom: '16px',
//       borderBottom: '2px solid #f3f4f6',
//       borderLeft: `4px solid ${color}`,
//       paddingLeft: '16px'
//     }),
//     statusIcon: {
//       fontSize: '24px'
//     },
//     statusTitle: (color) => ({
//       fontSize: '20px',
//       fontWeight: '600',
//       margin: '0',
//       flex: '1',
//       color: color
//     }),
//     statusCount: {
//       backgroundColor: '#f3f4f6',
//       color: '#6b7280',
//       padding: '4px 12px',
//       borderRadius: '12px',
//       fontSize: '14px',
//       fontWeight: '600'
//     },
//     projectsGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
//       gap: '20px'
//     }
//   };

//   const renderStatusSection = (statusKey) => {
//     const config = statusConfig[statusKey];
//     const projects = data[statusKey] || [];
    

//     if (projects.length === 0) return null;

//     return (
//       <div style={styles.statusSection} key={statusKey}>
//         <div style={styles.statusSectionHeader(config.color)}>
//           <span style={styles.statusIcon}>{config.icon}</span>
//           <h2 style={styles.statusTitle(config.color)}>{config.title}</h2>
//           <span style={styles.statusCount}>{projects.length}</span>
//         </div>
//         <div style={styles.projectsGrid}>
//           {projects.map(project => (
//             <ProjectCard
//               key={project.id}
//               project={project}
//               config={config}
//               onUpdateStatus={onUpdateStatus}
//               onViewHistory={onViewHistory}
//               userRole={userRole}
//             />
//           ))}
//         </div>
//       </div>
//     );
//   };

//   return (
     
//     <div style={styles.dashboard}>
//       {renderStatusSection('critical')}
//       {renderStatusSection('on_hold')}
//       {renderStatusSection('going_smooth')}
//       {renderStatusSection('no_status')}
//       {renderStatusSection('closed')}
//     </div>
//   );
// };

// export default ProjectDashboard;

// import React from 'react';
// import ProjectCard from './ProjectCard';

// const ProjectDashboard = ({ data, onUpdateStatus, onViewHistory, userRole }) => {
//   const statusConfig = {
//     going_smooth: {
//       title: 'Going Smooth',
//       icon: '✅',
//       color: '#10b981',
//       bgColor: '#d1fae5'
//     },
//     on_hold: {
//       title: 'On Hold',
//       icon: '⏸️',
//       color: '#f59e0b',
//       bgColor: '#fef3c7'
//     },
//     critical: {
//       title: 'Critical/Dangerous',
//       icon: '🚨',
//       color: '#ef4444',
//       bgColor: '#fee2e2'
//     },
//     ready_to_outsource: {
//       title: 'Ready to Outsource',
//       icon: '🤝',
//       color: '#8b5cf6',
//       bgColor: '#ede9fe'
//     },
//     closed: {
//       title: 'Closed',
//       icon: '✔️',
//       color: '#6b7280',
//       bgColor: '#f3f4f6'
//     },
//     no_status: {
//       title: 'No Status',
//       icon: '❓',
//       color: '#9ca3af',
//       bgColor: '#f9fafb'
//     }
//   };

//   const styles = {
//     dashboard: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '32px'
//     },
//     statusSection: {
//       background: 'white',
//       borderRadius: '12px',
//       padding: '24px',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//     },
//     statusSectionHeader: (color) => ({
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       marginBottom: '20px',
//       paddingBottom: '16px',
//       borderBottom: '2px solid #f3f4f6',
//       borderLeft: `4px solid ${color}`,
//       paddingLeft: '16px'
//     }),
//     statusIcon: {
//       fontSize: '24px'
//     },
//     statusTitle: (color) => ({
//       fontSize: '20px',
//       fontWeight: '600',
//       margin: '0',
//       flex: '1',
//       color: color
//     }),
//     statusCount: {
//       backgroundColor: '#f3f4f6',
//       color: '#6b7280',
//       padding: '4px 12px',
//       borderRadius: '12px',
//       fontSize: '14px',
//       fontWeight: '600'
//     },
//     projectsGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
//       gap: '20px'
//     },
//     emptyState: {
//       textAlign: 'center',
//       padding: '40px 20px',
//       color: '#9ca3af',
//       fontSize: '14px',
//       fontStyle: 'italic'
//     }
//   };

//   const renderStatusSection = (statusKey) => {
//     const config = statusConfig[statusKey];
//     const projects = data[statusKey] || [];
    
//     if (projects.length === 0) return null;

//     return (
//       <div style={styles.statusSection} key={statusKey}>
//         <div style={styles.statusSectionHeader(config.color)}>
//           <span style={styles.statusIcon}>{config.icon}</span>
//           <h2 style={styles.statusTitle(config.color)}>{config.title}</h2>
//           <span style={styles.statusCount}>{projects.length}</span>
//         </div>
//         <div style={styles.projectsGrid}>
//           {projects.map(project => (
//             <ProjectCard
//               key={project.id}
//               project={project}
//               config={config}
//               onUpdateStatus={onUpdateStatus}
//               onViewHistory={onViewHistory}
//               userRole={userRole}
//             />
//           ))}
//         </div>
//       </div>
//     );
//   };

//   // Check if all status categories are empty
//   const hasProjects = Object.keys(statusConfig).some(key => 
//     data && data[key] && data[key].length > 0
//   );

//   if (!data || !hasProjects) {
//     return (
//       <div style={styles.statusSection}>
//         <div style={styles.emptyState}>
//           <p>No projects found. Click "Add New Project" to get started.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.dashboard}>
//       {renderStatusSection('critical')}
//       {renderStatusSection('on_hold')}
//       {renderStatusSection('ready_to_outsource')}
//       {renderStatusSection('going_smooth')}
//       {renderStatusSection('no_status')}
//       {renderStatusSection('closed')}
//     </div>
//   );
// };

// export default ProjectDashboard;


import React, { useState, useContext } from 'react';
import AuthContext from "../contexts/AuthContext";
import ProjectCard from './ProjectCard';

const ProjectDashboard = ({ data, onUpdateStatus, onViewHistory, userRole }) => {
  const { user } = useContext(AuthContext);
  const [expandedRows, setExpandedRows] = useState(new Set());

  const statusConfig = {
    going_smooth: {
      title: 'Going Smooth',
      icon: '✅',
      color: '#10b981',
      bgColor: '#d1fae5',
      order: 4
    },
    on_hold: {
      title: 'On Hold',
      icon: '⏸️',
      color: '#f59e0b',
      bgColor: '#fef3c7',
      order: 2
    },
    critical: {
      title: 'Critical/Dangerous',
      icon: '🚨',
      color: '#ef4444',
      bgColor: '#fee2e2',
      order: 1
    },
    ready_to_outsource: {
      title: 'Ready to Outsource',
      icon: '🤝',
      color: '#8b5cf6',
      bgColor: '#ede9fe',
      order: 3
    },
    closed: {
      title: 'Closed',
      icon: '✔️',
      color: '#6b7280',
      bgColor: '#f3f4f6',
      order: 6
    },
    no_status: {
      title: 'No Status',
      icon: '❓',
      color: '#9ca3af',
      bgColor: '#f9fafb',
      order: 5
    }
  };

  // Flatten all projects into a single array with status info
  const allProjects = React.useMemo(() => {
    const projects = [];
    Object.keys(statusConfig).forEach(statusKey => {
      const statusProjects = data[statusKey] || [];
      statusProjects.forEach(project => {
        projects.push({
          ...project,
          statusKey,
          statusConfig: statusConfig[statusKey]
        });
      });
    });
    // Sort by status order (critical first)
    return projects.sort((a, b) => a.statusConfig.order - b.statusConfig.order);
  }, [data]);

  const toggleRow = (projectId) => {
    setExpandedRows(prev => {
      const newSet = new Set(prev);
      if (newSet.has(projectId)) {
        newSet.delete(projectId);
      } else {
        newSet.add(projectId);
      }
      return newSet;
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Check if current user can update this project
  const canUpdateProject = (project) => {
    const currentUserRole = userRole || user?.user_role || user?.role;
    
    // CEO and HR can update any project
    if (currentUserRole === 'CEO' || currentUserRole === 'HR') {
      return true;
    }
    
    // For managers, check if they manage this project
    if (currentUserRole === 'MANAGER') {
      const currentUserId = parseInt(user?.user_id || user?.id);
      const projectManagerId = parseInt(project.project_manager?.id);
      
      return currentUserId === projectManagerId;
    }
    
    return false;
  };

  const styles = {
    container: {
      backgroundColor: 'white',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
    tableWrapper: {
      overflowX: 'auto'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '14px'
    },
    thead: {
      backgroundColor: '#f9fafb',
      borderBottom: '2px solid #e5e7eb'
    },
    th: {
      padding: '12px 16px',
      textAlign: 'left',
      fontWeight: '600',
      color: '#374151',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      whiteSpace: 'nowrap'
    },
    tbody: {
      backgroundColor: 'white'
    },
    tr: (isExpanded) => ({
      borderBottom: '1px solid #e5e7eb',
      cursor: 'pointer',
      transition: 'background-color 0.15s',
      backgroundColor: isExpanded ? '#f9fafb' : 'white'
    }),
    td: {
      padding: '12px 16px',
      color: '#374151',
      verticalAlign: 'middle'
    },
    statusBadge: (color) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      backgroundColor: color,
      color: 'white',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '600',
      whiteSpace: 'nowrap'
    }),
    projectName: {
      fontWeight: '600',
      color: '#111827'
    },
    expandIcon: {
      fontSize: '12px',
      color: '#6b7280',
      marginRight: '8px',
      display: 'inline-block',
      transition: 'transform 0.2s',
      width: '12px'
    },
    expandIconRotated: {
      transform: 'rotate(90deg)'
    },
    expandedRow: {
      backgroundColor: '#f9fafb'
    },
    expandedContent: {
      padding: '20px 16px',
      borderTop: '1px solid #e5e7eb'
    },
    detailsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '16px',
      marginBottom: '16px'
    },
    detailItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    detailLabel: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    detailValue: {
      fontSize: '14px',
      color: '#111827',
      fontWeight: '500'
    },
    remarksSection: {
      marginTop: '16px',
      padding: '16px',
      backgroundColor: 'white',
      borderRadius: '8px',
      border: '1px solid #e5e7eb'
    },
    remarksLabel: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#6b7280',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginBottom: '8px',
      display: 'block'
    },
    remarksText: {
      fontSize: '14px',
      color: '#374151',
      lineHeight: '1.6',
      margin: 0,
      whiteSpace: 'pre-wrap'
    },
    actionsRow: {
      display: 'flex',
      gap: '12px',
      marginTop: '16px',
      paddingTop: '16px',
      borderTop: '1px solid #e5e7eb'
    },
    btnPrimary: {
      padding: '10px 20px',
      backgroundColor: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'background-color 0.2s'
    },
    btnSecondary: {
      padding: '10px 20px',
      backgroundColor: 'white',
      color: '#374151',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s'
    },
    readOnlyBadge: {
      padding: '10px 20px',
      backgroundColor: '#f3f4f6',
      color: '#6b7280',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    },
    editIconBtn: {
      padding: '6px 12px',
      backgroundColor: '#eff6ff',
      color: '#3b82f6',
      border: '1px solid #bfdbfe',
      borderRadius: '6px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s'
    },
    viewOnlyBadgeSmall: {
      padding: '4px 10px',
      backgroundColor: '#f3f4f6',
      color: '#6b7280',
      borderRadius: '6px',
      fontSize: '11px',
      fontWeight: '500',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      whiteSpace: 'nowrap'
    },
    emptyState: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#9ca3af',
      fontSize: '14px',
      fontStyle: 'italic'
    },
    noStatusText: {
      fontSize: '13px',
      color: '#9ca3af',
      fontStyle: 'italic'
    }
  };

  if (!data || allProjects.length === 0) {
    return (
      <div style={styles.container}>
        <div style={styles.emptyState}>
          <p>No projects found. Click "Add New Project" to get started.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead style={styles.thead}>
            <tr>
              <th style={{...styles.th, width: '40px'}}></th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Project Name</th>
              <th style={styles.th}>Manager</th>
              <th style={styles.th}>Last Updated</th>
              <th style={{...styles.th, width: '100px'}}>Updates</th>
              <th style={{...styles.th, width: '120px'}}>Actions</th>
            </tr>
          </thead>
          <tbody style={styles.tbody}>
            {allProjects.map((project) => {
              const isExpanded = expandedRows.has(project.id);
              const showUpdateButton = canUpdateProject(project);
              
              return (
                <React.Fragment key={project.id}>
                  <tr 
                    style={styles.tr(isExpanded)}
                    onMouseEnter={(e) => {
                      if (!isExpanded) {
                        e.currentTarget.style.backgroundColor = '#f9fafb';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isExpanded) {
                        e.currentTarget.style.backgroundColor = 'white';
                      }
                    }}
                  >
                    <td 
                      style={styles.td}
                      onClick={() => toggleRow(project.id)}
                    >
                      <span style={{
                        ...styles.expandIcon,
                        ...(isExpanded ? styles.expandIconRotated : {})
                      }}>
                        ▶
                      </span>
                    </td>
                    <td 
                      style={styles.td}
                      onClick={() => toggleRow(project.id)}
                    >
                      <span style={styles.statusBadge(project.statusConfig.color)}>
                        {project.statusConfig.icon} {project.latest_status?.status_display || 'No Status'}
                      </span>
                    </td>
                    <td 
                      style={{...styles.td, ...styles.projectName}}
                      onClick={() => toggleRow(project.id)}
                    >
                      {project.project_name}
                    </td>
                    <td 
                      style={styles.td}
                      onClick={() => toggleRow(project.id)}
                    >
                      {project.project_manager?.name || 'N/A'}
                    </td>
                    <td 
                      style={styles.td}
                      onClick={() => toggleRow(project.id)}
                    >
                      {project.latest_status ? (
                        formatDate(project.latest_status.created_at)
                      ) : (
                        <span style={styles.noStatusText}>No updates yet</span>
                      )}
                    </td>
                    <td 
                      style={styles.td}
                      onClick={() => toggleRow(project.id)}
                    >
                      <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                        {project.status_count || 0} update{project.status_count !== 1 ? 's' : ''}
                      </span>
                    </td>
                    <td style={styles.td}>
                      {showUpdateButton ? (
                        <button 
                          style={styles.editIconBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            onUpdateStatus(project);
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#dbeafe'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#eff6ff'}
                          title="Edit project status"
                        >
                          <span style={{ fontSize: '16px' }}>✏️</span>
                          <span> Edit </span>
                        </button>
                      ) : (
                        <div style={styles.viewOnlyBadgeSmall} title="You can only view this project">
                          <span style={{ fontSize: '14px' }}>👁️</span>
                          <span>View Only</span>
                        </div>
                      )}
                    </td>
                  </tr>
                  
                  {isExpanded && (
                    <tr style={styles.expandedRow}>
                      <td colSpan="7">
                        <div style={styles.expandedContent}>
                          {project.latest_status ? (
                            <>
                              <div style={styles.detailsGrid}>
                                <div style={styles.detailItem}>
                                  <span style={styles.detailLabel}>Updated By</span>
                                  <span style={styles.detailValue}>
                                    {project.latest_status.updated_by?.name || 'N/A'}
                                  </span>
                                </div>
                                <div style={styles.detailItem}>
                                  <span style={styles.detailLabel}>Last Update</span>
                                  <span style={styles.detailValue}>
                                    {formatDate(project.latest_status.created_at)}
                                  </span>
                                </div>
                                <div style={styles.detailItem}>
                                  <span style={styles.detailLabel}>Total Updates</span>
                                  <span style={styles.detailValue}>
                                    {project.status_count || 0}
                                  </span>
                                </div>
                              </div>

                              {project.latest_status.remarks && (
                                <div style={styles.remarksSection}>
                                  <span style={styles.remarksLabel}>Latest Remarks:</span>
                                  <p style={styles.remarksText}>{project.latest_status.remarks}</p>
                                </div>
                              )}
                            </>
                          ) : (
                            <div style={{ padding: '20px', textAlign: 'center', color: '#9ca3af' }}>
                              <p style={styles.noStatusText}>No status updates yet for this project</p>
                            </div>
                          )}

                          <div style={styles.actionsRow}>
                            <button 
                              style={styles.btnSecondary}
                              onClick={(e) => {
                                e.stopPropagation();
                                onViewHistory(project);
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                            >
                              <span>📋</span>
                              View Full History ({project.status_count || 0})
                            </button>
                            
                            {showUpdateButton ? (
                              <button 
                                style={styles.btnPrimary}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onUpdateStatus(project);
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                              >
                                <span>📝</span>
                                Update Status
                              </button>
                            ) : (
                              <div style={styles.readOnlyBadge}>
                                <span>👁️</span>
                                View Only
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectDashboard;